var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramBeaconTools40(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 20.5029V35.5029H7.08333C6.50804 35.5029 5.9872 35.2697 5.61019 34.8927C5.23319 34.5157 5 33.9949 5 33.4196V20.5029H20Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35 20.5029V33.4196C35 33.9949 34.7668 34.5157 34.3898 34.8927C34.0128 35.2697 33.492 35.5029 32.9167 35.5029H20V20.5029H35Z",
    fill: "#FAEC20",
    stroke: "#1E1E1E",
    strokeWidth: 1.1
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20 5.50293V20.5029H5V7.58626C5 7.01097 5.23319 6.49013 5.61019 6.11312C5.9872 5.73611 6.50804 5.50293 7.08333 5.50293H20Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.1
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9167 5.50293C33.492 5.50293 34.0128 5.73611 34.3898 6.11312C34.7668 6.49013 35 7.01097 35 7.58626V20.5029H20V5.50293H32.9167Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.1
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.75 13.0029H31.25",
    stroke: "#1E1E1E",
    strokeWidth: 1.1
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.75 26.7529H31.25",
    stroke: "#1E1E1E",
    strokeWidth: 1.1
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M23.75 29.2529H31.25",
    stroke: "#1E1E1E",
    strokeWidth: 1.1
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1431 25.6465L14.8571 30.3605",
    stroke: "#1E1E1E",
    strokeWidth: 1.1
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8569 25.6465L10.1429 30.3605",
    stroke: "#1E1E1E",
    strokeWidth: 1.1
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M8.75 13.0029H16.25",
    stroke: "#1E1E1E",
    strokeWidth: 1.1
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 9.25293L12.5 16.7529",
    stroke: "#1E1E1E",
    strokeWidth: 1.1
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramBeaconTools40);
export default __webpack_public_path__ + "static/media/pictogramBeaconTools40.452e597bb04b9466dab2de8c2714545e.svg";
export { ForwardRef as ReactComponent };